export enum ColorMode {
  Light = "light",
  Dark = "dark",
}
